'use strict';

import 'bootstrap/js/src/tab'
import 'bootstrap/js/src/tooltip'

const AColorPicker = require('a-color-picker');
const fip = require( '@fonticonpicker/fonticonpicker' );
import 'select2';

window.TWER_HELPERS = {
    AColorPicker: AColorPicker,
    fip : fip,
};



jQuery.noConflict();
(function ($) {
    $(function () {

        // TWER Metabox at Marker Page
        // Conditional to show or hide toggle 'Open by Default', Trigger by select 'Open popup on'
        const $selectOpenOn = $('select#treweler-popup-open-group-open-on, select#popup_open_group_popup_style');
        const $defaulOpen = $('label[for=treweler-popup-open-group-open-default], label[for="popup_open_group_open_default"]');

        // Hide if match condition
        if ('always_open' === $selectOpenOn.val()) {
            $defaulOpen.hide();
        }

        // Handle Change
        $selectOpenOn.on('change', function () {
            if ('always_open' === $(this).val()) {
                $defaulOpen.hide();
            } else {
                $defaulOpen.show();
            }
        });



        const $selectOpenOn1 = $('select#treweler-popup-image-position');
        const $defaulOpen1 = $('#treweler-popup-image-width');

        // Hide if match condition
        if ('top' === $selectOpenOn1.val()) {
            $defaulOpen1.closest('tr').addClass('hidden-row-class');
        }

        // Handle Change
        $selectOpenOn1.on('change', function () {
            if ('top' === $(this).val()) {
                $defaulOpen1.closest('tr').addClass('hidden-row-class');
            } else {
                $defaulOpen1.closest('tr').removeClass('hidden-row-class');
            }
        });



        // Category Page(Map)
        let catFooter = '<div class="form-wrap edit-term-notes"><p>Deleting a category does not delete the markers or routes in that category. Instead, markers or routes that were only assigned to the deleted category are set to the default category <b>Uncategorized</b>. The default category cannot be deleted.</p></div>';
        $('.post-type-map.taxonomy-map-category #posts-filter').append(catFooter);

        // Disable Default Category
        if ($(".post-type-map.taxonomy-map-category").length) {
            $('.post-type-map.taxonomy-map-category #tag-' + twer_taxonomy.default_id + ' .check-column').html('&nbsp;');
            $('.post-type-map.taxonomy-map-category #tag-' + twer_taxonomy.default_id + ' .delete').html('&nbsp;');

            if ($('.post-type-map.taxonomy-map-category #edittag').find('input[name="tag_ID"]').val() === twer_taxonomy.default_id) {
                $('.post-type-map.taxonomy-map-category #delete-link').html('&nbsp;');
            }
        }

        var tabs = $('.nav-tabs:not(.js-not-save-state-for-tab)'),
          $tab = $('a[data-toggle="tab"]:not(.js-not-save-state-for-tab)');

        // Open default saved active Tab
        if(tabs.length > 0) {
            tabs.each(function () {
                var id =  $(this).attr('id');
                id += window.location.href.replace(/\//g, '_');
                id = id.replace(/\./g,'_');
                var activeTab = localStorage.getItem("nav_" + id) ? localStorage.getItem("nav_" + id) : '#';
                var checkid = "nav_" + id;
                if(activeTab !== '#' && checkid.indexOf('post-new') === -1) {
                    $(this).find('a[href*="'+activeTab+'"]').tab('show');
                    $('.CodeMirror').each(function(i, el){
                        el.CodeMirror.refresh();
                    });
                }
            });
        }


        // Default tab action (functionality as bootstrap v4.0 ++)
        $tab.on('shown.bs.tab', function (e) {
            if(e.target) {
                let id = $(e.target).closest('.nav-tabs').attr('id');
                id += window.location.href.replace(/\//g, '_');
                id = id.replace(/\./g,'_');
                localStorage.setItem("nav_" + id, $(e.target).attr('href'));
            }
            $('.CodeMirror').each(function(i, el){
                el.CodeMirror.refresh();
            });
        });

        $('.js-twer-select-2').select2({
            placeholder: 'No maps selected',
        });




        $('.twer-tr-toggle:not(.d-none) select.js-field-multiselect').select2({
            placeholder: 'No values selected',
            width: '100%',
            minimumResultsForSearch: -1,
        });


        $('#treweler-store-locator-radius-size').select2({
            placeholder: '',
            width : '100%'
        });
        $('#treweler-store-locator-radius-size').on('change', function (e) {
            const selectValues = $(this).select2('val');
            $('#treweler-store-locator-radius-default').empty();
            if(selectValues.length > 0) {
                $.each(selectValues, function(key, value) {
                    let valueLabel = value;
                    if (valueLabel === 'unlim') {
                        valueLabel = twer_ajax.strings.unlim;
                    }
                    $('#treweler-store-locator-radius-default').append($("<option></option>").attr("value", value).text(valueLabel));
                });
            } else {
                $('#treweler-store-locator-radius-default').append($("<option></option>").attr("value", 10).text(10));
            }
        });

    });
})(jQuery);
